module.exports = __webpack_public_path__ + "static/media/hero-bg.ac2463cf.svg";